import React from 'react';
import * as Sentry from '@sentry/react';
import { Route, Routes } from 'react-router-dom';
import Home from '../pages/Home';
import ProductVideoDetail from '../pages/ProductVideoDetail';
import ProductDigitalDetail from '../pages/ProductDigitalDetail';
import PurchaseHistoryList from '../pages/PurchaseHistoryList';
import PurchaseComplete from '../pages/PurchaseComplete';
import PurchaseFail from '../pages/PurchaseFail';
import VideoLiveDetail from '../pages/VideoLiveDetail';
import VideoClipDetail from '../pages/VideoClipDetail';
import StarbeatPurchase from '../pages/StarbeatPurchase';
import StarbeatHistoryList from '../pages/StarbeatHistoryList';
import Error from '../components/Common/Error';

const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);

const AppRoutes = () => {
  return (
    <SentryRoutes>
      <Route path='/' element={<Home />} />
      <Route path='/product-video-detail/:id' element={<ProductVideoDetail />} />
      <Route path='/product-digital-detail/:id' element={<ProductDigitalDetail />} />
      <Route path='/purchase-history' element={<PurchaseHistoryList />} />
      <Route path='/purchase-complete' element={<PurchaseComplete />} />
      <Route path='/purchase-fail/' element={<PurchaseFail />} />
      <Route path='/video-live-detail/:id' element={<VideoLiveDetail />} />
      <Route path='/video-clip-detail/:id' element={<VideoClipDetail />} />
      <Route path='/starbeat-purchase' element={<StarbeatPurchase />} />
      <Route path='/starbeat-history' element={<StarbeatHistoryList />} />
      {/* 404 오류 페이지 */}
      {/* 에러 발생 시 라우팅할 컴포넌트, errorType은 해당 컴포넌트 switch문 참고 */}
      <Route path='*' element={<Error errorType={'404'} />} />
      <Route path='/error' element={<Error errorType={'500'} />} />
    </SentryRoutes>
  );
};

export default AppRoutes;
